<template>
	<div
		class="p-d-flex p-flex-column p-flex-md-row p-text-left p-justify-center p-grid"
	>
		<Accordion class="p-col-12" :multple="false" :activeIndex="active">
			<AccordionTab>
				<template #header>
					<div class="p-d-flex p-justify-between" style="width: 100%">
						<p>
							{{
								firstName && lastName != null
									? firstName + " " + lastName
									: "Student #" + studentNumber
							}}
						</p>
						<p>
							Total: CAD $<span>{{
								!isNaN(studentTotalAmount)
									? studentTotalAmount.toFixed(2)
									: "0.00"
							}}</span>
						</p>
					</div>
				</template>

				<div class="p-fluid p-formgrid">
					<div class="name p-grid">
						<div class="p-col-12 p-lg-4 p-field">
							<label class="p-text-bold" for="firstName">First Name: *</label>
							<InputText id="firstName" type="text" v-model="firstName" />
							<small v-if="v$.firstName.$invalid && submitted" class="p-error">
								{{
									v$.firstName.required.$message.replace("Value", "First Name")
								}}
							</small>
						</div>

						<div class="p-col-12 p-lg-4 p-field">
							<label class="p-text-bold" for="lastName">Last Name: *</label>
							<InputText id="lastName" type="text" v-model="lastName" />
							<small v-if="v$.lastName.$invalid && submitted" class="p-error">
								{{
									v$.lastName.required.$message.replace("Value", "Last Name")
								}}
							</small>
						</div>

						<div class="p-col-12 p-lg-4 p-field">
							<label class="p-text-bold">Choose a Grade: *</label>
							<Dropdown
								v-model="selectedGrade"
								:options="grades"
								optionLabel="label"
								placeholder="Grade"
							/>
							<small
								v-if="v$.selectedGrade.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.selectedGrade.required.$message.replace("Value", "Grade")
								}}
							</small>
						</div>
					</div>
				</div>

				<div class="programSelections p-grid">
					<div v-if="showBusPlan" class="busPlanSelections p-col-12 p-lg-6">
						<div class="busSemester">
							<label class="p-text-bold">
								Pick a semester for Bus Service : *
							</label>
							<div class="p-d-flex p-flex-column">
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'busSemester1'"
										name="busSemester1"
										value="Semester 1"
										v-model="busSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'busSemester1'">
										Semester 1
									</label>
								</div>
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'busSemester2'"
										name="busSemester2"
										value="Semester 2"
										v-model="busSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'busSemester2'">
										Semester 2
									</label>
								</div>
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'busBoth'"
										name="busBoth"
										value="Both Semesters"
										v-model="busSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'busBoth'">
										Both
									</label>
								</div>
								<div
									v-if="!hideNotRequired"
									class="semesters field-radiobutton p-pt-2"
								>
									<RadioButton
										:id="studentNumber + 'busNotRequired'"
										name="busNotRequired"
										value="Not Required"
										v-model="busSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'busNotRequired'">
										Not Required
									</label>
								</div>
							</div>
							<small
								v-if="v$.busSemester.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.busSemester.required.$message.replace(
										"Value",
										"Bus Semester"
									)
								}}
							</small>
						</div>

						<div v-if="busSemester != 'Not Required'" class="p-field p-pt-3">
							<label class="p-text-bold">Choose a Bus service: *</label>
							<Dropdown
								v-model="selectedBusService"
								:options="busServices"
								optionLabel="label"
								placeholder="Bus Services"
							/>
						</div>
					</div>

					<div v-if="showMealPlan" class="mealPlanSelections p-col-12 p-lg-6">
						<div class="mealSemester">
							<label class="p-text-bold">
								Pick a semester for Cafeteria & Lunch Service :
								<span
									v-if="selectedMealProgram.value != 'MLF'"
									class="p-text-bold"
									>*</span
								>
							</label>
							<div class="p-d-flex p-flex-column">
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'mealSemester1'"
										name="mealSemester1"
										value="Semester 1"
										v-model="mealSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'mealSemester1'">
										Semester 1
									</label>
								</div>
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'mealSemester2'"
										name="mealSemester2"
										value="Semester 2"
										v-model="mealSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'mealSemester2'">
										Semester 2
									</label>
								</div>
								<div class="semesters field-radiobutton p-pt-2 p-pr-3">
									<RadioButton
										:id="studentNumber + 'mealBoth'"
										name="mealBoth"
										value="Both Semesters"
										v-model="mealSemester"
									/>
									<label class="p-pl-1" :for="studentNumber + 'mealBoth'">
										Both
									</label>
								</div>

								<div
									v-if="!hideNotRequired"
									class="semesters field-radiobutton p-pt-2"
								>
									<RadioButton
										:id="studentNumber + 'mealNotRequired'"
										name="mealNotRequired"
										value="Not Required"
										v-model="mealSemester"
									/>
									<label
										class="p-pl-1"
										:for="studentNumber + 'mealNotRequired'"
									>
										Not Required
									</label>
								</div>
							</div>
							<small
								v-if="v$.mealSemester.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.mealSemester.required.$message.replace(
										"Value",
										"Meal Semester"
									)
								}}
							</small>
						</div>
						<div v-if="mealSemester != 'Not Required'" class="p-field p-pt-3">
							<label class="p-text-bold">
								Choose a Cafeteria and Lunch service : *
							</label>
							<Dropdown
								v-model="selectedMealProgram"
								:options="mealProgramServices"
								optionLabel="label"
								placeholder="Meal Services"
							/>
						</div>
						<div
							v-if="loadFobSelected && mealSemester != 'Not Required'"
							class="p-pt-2"
						>
							<label for="fobCustomAmount" class="p-text-bold p-pl-1">
								Amount to load onto FOB:
							</label>
							<InputNumber
								id="fobCustomAmount"
								v-model="selectedMealProgram.price"
							/>
							<small
								v-if="v$.mealTotalAmount.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.mealTotalAmount.minValue.$message.replace(
										"The minimum value allowed is 1",
										"Please enter an amount to proceed"
									)
								}}
							</small>
						</div>
					</div>

					<p style="width: 100%" class="p-text-center">
						<small
							v-if="v$.studentTotalAmount.$invalid && submitted"
							class="p-error"
						>
							{{
								v$.studentTotalAmount.minValue.$message.replace(
									"The minimum value allowed is 1",
									"Please select a Program before continuing"
								)
							}}
						</small>
					</p>
				</div>
			</AccordionTab>
		</Accordion>
	</div>
</template>

<script>
import { useFormDataStore } from "../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import { minValue, required } from "@vuelidate/validators";

export default {
	name: "StudentInfoCard",
	data() {
		return {
			active: 0,
			submitted: false,
			studentTotalAmount: 0,
			hideNotRequired: false,
			firstName: null,
			lastName: null,
			selectedGrade: null,
			grades: [
				{ label: "Grade 9", value: "G9" },
				{ label: "Grade 10", value: "G10" },
				{ label: "Grade 11", value: "G11" },
				{ label: "Grade 12", value: "G12" },
			],
			busSemester: "",
			busTotalAmount: 0,
			selectedBusService: {
				label: "Not Required",
				value: "BNA",
				price: 0,
			},
			busServices: [
				{
					label: "Not Required",
					value: "BNA",
					price: 0,
				},
				{
					label: "Within the city of Regina - both ways: $800",
					value: "WRBW",
					price: 800,
				},
				{
					label: "Within the city of Regina - one way - AM: $550",
					value: "WROWA",
					price: 550,
				},
				{
					label: "Within the city of Regina - one way - PM: $550",
					value: "WROWP",
					price: 550,
				},
				{
					label: "White City - both ways: $1065",
					value: "WHBW",
					price: 1065,
				},
				{
					label: "White City - one way - AM: $690",
					value: "WHOWA",
					price: 690,
				},
				{
					label: "White City - one way - PM: $690",
					value: "WHOWP",
					price: 690,
				},
			],
			mealSemester: "",
			selectedMealProgram: {
				label: "Not Required",
				value: "MNA",
				price: 0,
			},
			loadFobSelected: false,
			mealTotalAmount: 0,
			mealProgramServices: [
				{
					label: "Not Required",
					value: "MNA",
					price: 0,
				},
				{
					label: "Semester Meal Plan: $880",
					value: "SMP",
					price: 880,
				},
				{
					label: "Load Fob: Custom Amount",
					value: "MLF",
					price: 0,
				},
			],
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			v$: useVuelidate(),
			store,
		};
	},
	validations() {
		return {
			firstName: { required },
			lastName: { required },
			selectedGrade: { required },
			selectedMealProgram:
				this.mealSemester != "Not Required" ? { required } : "",
			mealSemester:
				this.selectedMealProgram.value != "MNA" &&
				this.selectedMealProgram.value != "MLF"
					? { required }
					: "",
			busSemester: this.selectedBusService.value != "BNA" ? { required } : "",
			studentTotalAmount: { minValue: minValue(1) },
			mealTotalAmount:
				this.selectedMealProgram.value === "MLF"
					? { minValue: minValue(1) }
					: 0,
		};
	},
	props: {
		studentNumber: Number,
		validateForm: Number,
		validateAllStudentInfoForms: Function,
		showBusPlan: {
			type: Boolean,
			default: false, // change back to true when live (Aug. 29, 2024)
		},
		showMealPlan: {
			type: Boolean,
			default: true,
		},
	},
	beforeMount() {
		if (this.showBusPlan === false) {
			this.hideNotRequired = true;

			this.selectedMealProgram = {};
			this.mealProgramServices.shift();
		}

		if (this.showMealPlan === false) {
			this.hideNotRequired = true;

			this.selectedBusService = {};
			this.busServices.shift();
		}
	},
	watch: {
		selectedBusService() {
			this.calculateBusTotal();
		},
		busSemester() {
			if (this.busSemester === "Not Required") {
				this.selectedBusService = {
					label: "Not Required",
					value: "BNA",
					price: 0,
				};

				this.busTotalAmount = 0;
			}

			this.calculateBusTotal();
		},
		selectedMealProgram() {
			this.calculateMealTotal();
			if (this.selectedMealProgram.value === "MLF") {
				this.selectedMealProgram.price = 0;
				this.loadFobSelected = true;
			} else if (this.selectedMealProgram.value != "MLF") {
				this.loadFobSelected = false;
				// this.selectedMealProgram.price = 0;
			}
		},
		"selectedMealProgram.price"() {
			this.calculateMealTotal();
		},
		loadFobSelected() {
			this.calculateMealTotal();
		},
		mealSemester() {
			if (this.mealSemester === "Not Required") {
				this.selectedMealProgram = {
					label: "Not Required",
					value: "MNA",
					price: 0,
				};

				this.mealTotalAmount = 0;
			}

			this.calculateMealTotal();
		},
		busTotalAmount() {
			this.calculateStudentTotal();
		},
		mealTotalAmount() {
			this.calculateStudentTotal();
		},
		studentTotalAmount() {
			if (this.studentTotalAmount != null) {
				this.$emit("studentTotal", this.studentTotalAmount, this.studentNumber);
			}
		},
		async validateForm() {
			const isFormValid = await this.v$.$validate();
			this.submitted = true;
			if (!isFormValid) {
				this.validateAllStudentInfoForms(false, this.studentNumber);
			} else {
				this.store.setS1StudentInfoData(
					{
						firstName: this.firstName,
						lastName: this.lastName,
						studentTotalAmount: this.studentTotalAmount,
						selectedGrade: this.selectedGrade,
						busSemester: this.busSemester,
						busTotalAmount: this.busTotalAmount,
						selectedBusService: this.selectedBusService,
						mealSemester: this.mealSemester,
						mealTotalAmount: this.mealTotalAmount,
						selectedMealProgram: this.selectedMealProgram,
					},
					this.studentNumber
				);
				this.validateAllStudentInfoForms(true, this.studentNumber);
			}
		},
	},
	methods: {
		calculateStudentTotal() {
			this.studentTotalAmount = this.busTotalAmount + this.mealTotalAmount;
		},
		calculateBusTotal() {
			if (this.selectedBusService.value === "BNA") {
				this.busTotalAmount = 0;
			} else if (this.busSemester.includes("Both")) {
				this.busTotalAmount = this.selectedBusService.price * 2;
			} else {
				this.busTotalAmount = this.selectedBusService.price;
			}
		},
		calculateMealTotal() {
			if (this.selectedMealProgram.value === "MNA") {
				this.mealTotalAmount = 0;
			} else if (
				this.mealSemester.includes("Both") &&
				this.selectedMealProgram.value != "MLF"
			) {
				this.mealTotalAmount = this.selectedMealProgram.price * 2;
			} else {
				this.mealTotalAmount = this.selectedMealProgram.price;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.field-radiobutton label {
	cursor: pointer;
}
</style>
